import { useDispatch } from 'react-redux';
import { useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { submitTariffBook } from 'features/buku-tarif/shared/api/submitTariffBook';
import { tariffBookKeys } from 'features/buku-tarif/shared/api/queryKeys';
import { useRetryableAction } from 'shared/hooks/useRetryableAction';
import { setProgressModalOpen } from 'store/buku-tarif/bukuTarifSlice';
import { getErrorMessage } from 'shared/utils/errorMessage';
import { showErrorToastWithRetry } from 'shared/utils/showErrorToastWithRetry';

export const useSubmitUploadTariffBook = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const { execute, isLoading } = useRetryableAction(
    (id) => submitTariffBook(id),
    {
      onError: (error, { isRetryExhausted, status }) => {
        const message = getErrorMessage(error);
        if (status >= 500 && isRetryExhausted) {
          showErrorToastWithRetry(`Submit tariff book: ${message}`, () =>
            execute()
          );
        } else {
          toast.error(`Submit tariff book: ${message}`);
        }
      },
    }
  );

  const handleSubmit = async (id) => {
    const result = await execute(id);
    if (result) {
      queryClient.invalidateQueries(tariffBookKeys.all);
      dispatch(setProgressModalOpen(true));
    }
  };

  return { handleSubmit, loading: isLoading };
};
